<div class="common-modal__container">
  <div class="common-modal__header">
    <span
      class="common-modal__text-header"
      [afTranslate]="'field-type-consult-lists.consult-list'">
      _Consultar listas
    </span>
  </div>
  @if (consultListsModal.configuration.infoModal.configurated) {
    <div class="common-modal__content">
      <span
        [afTranslate]="'consult-lists-modal.introduction-modal'"
        class="common-modal__content-header-info">
        _Este es un resumen de tu consulta. Genera el informe para obtener un documento con todos los datos disponibles y asociarlo a la evaluación del cliente.
      </span>
      <div class="common-modal__form-container">
        <div
          [ngClass]="{
            'common-status-message__g-container-alert': this.consultListsModal.configuration.infoModal.resultColor === 'red',
            'common-status-message__g-container-warning': this.consultListsModal.configuration.infoModal.resultColor === 'yellow',
            'common-status-message__g-container-success': this.consultListsModal.configuration.infoModal.resultColor === 'green',
          }">
          <i
          [ngClass]="{
            'lf-icon-close-round-full': this.consultListsModal.configuration.infoModal.resultColor === 'red',
            'lf-icon-warning-full': this.consultListsModal.configuration.infoModal.resultColor === 'yellow',
            'lf-icon-check-round-full': this.consultListsModal.configuration.infoModal.resultColor === 'green',
          }"
          class="common-status-message__icon-md">
          </i>
          <div class="common-status-message__g-content">
            <div class="common-status-message__g-icon-text-content">
              <div class="common-status-message__g-title-subtitle">
                <span class="common-status-message__g-title">
                  {{consultListsModal.configuration.infoModal.messageAnswer}}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="common-modal__form-container-overflow max-h-[505px]">
          <div class="common-consult-list-modal__info-container">
            <div class="common-consult-list-modal__title-container">
              <span class="common-consult-list-modal__title">
                {{
                  consultListsModal.configuration.typePerson === 'natural'
                  ? consultListsModal.configuration.personData.name + ' ' + consultListsModal.configuration.personData.surname1 + ' ' + (consultListsModal.configuration.personData.surname2 ?? '')
                  : consultListsModal.configuration.personData.socialReason
                }}
              </span>
              <span class="common-consult-list-modal__subtitle">
                {{consultListsModal.configuration.personData.documentNumber}}
              </span>
            </div>
            <div class="common-consult-list-modal__secondary-container">
              <div class="common-consult-list-modal__secondary-container-row">
                <span
                  [afTranslate]="'consult-lists-modal.proceedings'"
                  class="common-consult-list-modal__secondary-label">
                  _Expediente
                </span>
                <span class="common-consult-list-modal__secondary-value">
                  {{consultListsModal.configuration.infoModal.dossierId}}
                </span>
              </div>
              <div class="common-consult-list-modal__secondary-container-row">
                <span
                  [afTranslate]="'all-documentation.consult-date'"
                  class="common-consult-list-modal__secondary-label">
                  _Fecha de consulta
                </span>
                <span class="common-consult-list-modal__secondary-value">
                  {{consultListsModal.configuration.infoModal.exportDate | convertDate}}
                </span>
              </div>
              <div class="common-consult-list-modal__secondary-container-row">
                <span
                  [afTranslate]="'consult-lists-modal.information-provider'"
                  class="common-consult-list-modal__secondary-label">
                  _Proveedor de la información
                </span>
                <span class="common-consult-list-modal__secondary-value">
                  {{consultListsModal.configuration.infoModal.provider}}
                </span>
              </div>
              <div class="common-consult-list-modal__secondary-container-row">
                <span
                  [afTranslate]="'consult-lists-modal.detections'"
                  class="common-consult-list-modal__secondary-label">
                  _Nr de detecciones
                </span>
                <span class="common-consult-list-modal__secondary-value">
                  {{consultListsModal.configuration.infoModal.detections?.length}}
                </span>
              </div>
            </div>
          </div>
          @if (consultListsModal.configuration.infoModal.detections?.length) {
            <p-accordion
              styleClass="common-consult-list-modal__detection-list"
              expandIcon="lf-icon-angle-down common-icon__md"
              collapseIcon="lf-icon-angle-up common-icon__md"
              [multiple]="true">
              @for (detection of consultListsModal.configuration.infoModal.detections; track $index) {
                <p-accordionTab
                  tabStyleClass="common-consult-list-modal__detection"
                  [header]="detection.name">
                  @if (detection.confidenceLevel) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.confidence-level'"
                        class="common-consult-list-modal__detection-row--label">
                        _Nivel de confianza
                      </span>
                      <span class="common-consult-list-modal__detection-row--value">
                        {{detection.confidenceLevel}}
                      </span>
                    </div>
                  }
                  @if (detection.personType) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.person-type'"
                        class="common-consult-list-modal__detection-row--label">
                        _Tipo de persona
                      </span>
                      <span
                        [afTranslate]="detection.personType === 'NATURAL' ? 'consult-lists-modal.person-natural' : 'consult-lists-modal.person-artifitial'"
                        class="common-consult-list-modal__detection-row--value">
                        {{detection.confidenceLevel}}
                      </span>
                    </div>
                  }
                  @if (detection.post) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.post'"
                        class="common-consult-list-modal__detection-row--label">
                        _Post
                      </span>
                      <span class="common-consult-list-modal__detection-row--value">
                        {{detection.post}}
                      </span>
                    </div>
                  }
                  @if (detection.state) {
                    <div class="common-consult-list-modal__detection-row">
                      <div
                        [afTranslate]="'consult-lists-modal.state'"
                        class="common-consult-list-modal__detection-row--label">
                        _Estado
                      </div>
                      <div
                        [afTranslate]="detection.state === 'ACTIVE' ? 'consult-lists-modal.state-active' : 'consult-lists-modal.state-inactive'"
                        class="common-consult-list-modal__detection-row--value">
                      </div>
                    </div>
                  }
                  @if (detection.creationDate) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.creation-date'"
                        class="common-consult-list-modal__detection-row--label">
                        _Fecha de creación
                      </span>
                      <span class="common-consult-list-modal__detection-row--value">
                        {{detection.creationDate | convertDate:'without-time'}}
                      </span>
                    </div>
                  }
                  @if (detection.aliases?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.alias'"
                        class="common-consult-list-modal__detection-row--label">
                        _Alias
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (alias of detection.aliases; track $index) {
                          <div>
                            {{alias.name}} {{alias.aliasType}}
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.birthDates?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.born-dates'"
                        class="common-consult-list-modal__detection-row--label">
                        _Fechas de nacimiento
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (birthDate of detection.birthDates; track $index) {
                          <div>
                            {{birthDate.bornDate | convertDate: 'without-time'}}
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.addresses?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.addresses'"
                        class="common-consult-list-modal__detection-row--label">
                        _Direcciones
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (address of detection.addresses; track $index) {
                          <div>
                            @if (address.comments) {
                              {{address.comments}} {{address.country}}
                            }
                            @else {
                              {{address.address1}} {{address.city}} {{address.country}}
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.identificationDocuments?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.identification'"
                        class="common-consult-list-modal__detection-row--label">
                        _Documentos de identidad
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (identification of detection.identificationDocuments; track $index) {
                          <div>
                            <span>{{identification.documentNumber}}</span>
                            @if (identification.type) {
                              <span>&nbsp;(<span [afTranslate]="'consult-lists-modal.' + identification.type.toLowerCase()"></span>)</span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.prpType) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.prp-type'"
                        class="common-consult-list-modal__detection-row--label">
                        _Tipo de detección
                      </span>
                      <span class="common-consult-list-modal__detection-row--value">
                        {{detection.prpType}}
                      </span>
                    </div>
                  }
                  @if (detection.prpCategories?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.prp-categories'"
                        class="common-consult-list-modal__detection-row--label">
                        _Categorías de detección
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (category of detection.prpCategories; track $index) {
                          <div>
                            {{category}}
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.sanctions?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.sanctions'"
                        class="common-consult-list-modal__detection-row--label">
                        _Lista de sanciones
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (sanction of detection.sanctions; track $index) {
                          <div>
                            {{sanction.name}}: {{sanction.startingDate | convertDate: 'without-time'}}
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.activities?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.activities'"
                        class="common-consult-list-modal__detection-row--label">
                        _Ocupaciones
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (activity of detection.activities; track $index) {
                          <div>
                            <span>{{activity.description}} ({{activity.type}} - {{activity.post}})</span>
                            @if (activity.startingDateInPostSpecified) {
                              <span>&nbsp;<span [afTranslate]="'consult-lists-modal.from'">_Desde</span>
                                <span>: {{activity.startingDateInPost | convertDate: 'without-time'}}</span>
                              </span>
                            }
                            @if (activity.endingDateInPostSpecified) {
                              <span>&nbsp;<span [afTranslate]="'consult-lists-modal.until'">_Hasta</span>
                                <span>: {{activity.endingDateInPost | convertDate: 'without-time'}}</span>
                              </span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (detection.relations?.length) {
                    <div class="common-consult-list-modal__detection-row">
                      <span
                        [afTranslate]="'consult-lists-modal.relations'"
                        class="common-consult-list-modal__detection-row--label">
                        _Relaciones conocidas
                      </span>
                      <div class="common-consult-list-modal__detection-row--value">
                        @for (relation of detection.relations; track $index) {
                          <div>
                            <span>{{relation.name}}.&nbsp;</span>
                            <span [afTranslate]="'consult-lists-modal.relation'">_Relación</span>
                            <span>: {{relation.type}}</span>
                            @if (!relation.previous) {
                              <span>
                                (<span [afTranslate]="'consult-lists-modal.relation-current'">_Relación actual</span>)
                              </span>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </p-accordionTab>
              }
            </p-accordion>
          }
        </div>
      </div>
    </div>
  }
  <div class="common-modal__footer">
    <button
      (click)="handleDismiss()"
      class="common-button__text-border">
      <span
        [afTranslate]="'common.close'"
        class="common-button__text-title">
        _Cerrar
      </span>
    </button>
    <button
      (click)="generateReport()"
      class="common-button__text">
      <span
        [afTranslate]="'finish-block-modal.generate-report'"
        class="common-button__text-title">
        _Generar informe
      </span>
    </button>
  </div>
</div>
<report-consult-lists-pdf
  class="common__pdf-hidde-element"
  [configuration]="consultListsModal.configuration">
</report-consult-lists-pdf>
